<template>
  <el-dialog :visible.sync="dialogVisible"
             width="960px"
             class="loginDialog"
             :center='true'
             top="5vh"
             :before-close="close">
    <div class="userPactView">
      <div class="userPactContent">
        <div class="title font24 tc mb30 fontw">快哦用户协议</div>
        <div class="mb60">
          <p class="item">“快哦”是电商企业智能工具平台，为电商企业提供优质服务。为保障您更好的使用快哦平台及服务，请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的以及其他涉及您重大权益的条款，这些条款可能以加黑方式提示您重点注意。如果您未满18周岁，请在法定监护人的陪同下完成或由法定监护人代理完成。您在本软件上注册、登录、使用即视为您已充分阅读并完全自愿接受本用户协议的各项内容，包括快哦对本协议随时所做的任何修改，并成为快哦用户。本协议在您与快哦之间产生法律效力，成为对双方均具有约束力的法律文件。</p>

        </div>
        <div class="mb60">
          <p class="item font16 fontw mb10">一、服务说明</p>
          <p>1. 服务主体：本服务由快哦为您提供。“快哦”是福建大泽网络科技有限公司运营的网络平台，本协议项下的“快哦”根据不同的语境可能指快哦网页、移动端及围绕快哦软件产品提供的相关技术服务。“用户”是指注册、登录、使用快哦及服务的使用人，在本协议中更多地称呼为“您”。</p>
          <p>2. 服务内容：快哦是电商企业智能工具平台，将为您提供包括但不限于各行业及文本、图片、网址查询服务。</p>
          <p>3. 服务平台：快哦提供本软件或服务包括但不限于Ios、Android等多个应用版本，域名为www.kuaio.cn的网站，以及多种类小程序中，让您可以随时随地完成使用。快哦也会不断进行更新和改进，以满足您日益增长的需求。</p>
        </div>
        <div class="mb60">
          <p class="item font16 fontw mb10">二、关于“账号”</p>
          <p class="fontw">1. 账号注册</p>
          <p class="itemP"><span>1.1</span>您在使用快哦各项服务前需提供个人真实信息完成账号注册和密码设置，或通过快哦认可的第三方账号（如1688、微信账号、微博账号等）进行注册，为保证您享用的平台服务安全有效且不断优化，您同意授权快哦对您的个人信息进行验证和合理使用。</p>
          <p class="itemP"><span>1.2</span>您注册成功的账号密码仅可供您一人正当使用，不应用于违法违规的用途、不应用于损害他方利益、不应恶意批量注册、不应将其透露、出借、赠与或转让给他人等，否则您须对不当使用负责。</p>
          <p class="itemP"><span>1.3</span>同一用户只能注册并绑定一个账号。同一手机号码、第三方账号，满足任一条件均视为同一用户。</p>
          <p class="itemP"><span>1.4</span>您需对您提供的注册资料的真实性、准确性、合法性负责，并及时更新您的资料。若您提供任何违法、不道德或快哦认为不适合在快哦上展示的资料，或是快哦有理由怀疑你的资料属于程序或恶意操作，快哦有权暂停或终止您的帐号，并拒绝您于现在和未来使用本服务之全部或任何部分。</p>
          <p class="itemP"><span>1.5</span>快哦无须对任何用户的任何登记资料承担任何责任，包括但不限于鉴别、核实任何登记资料的真实性、正确性、完整性、适用性及/或是否为最新资料的责任。</p>
          <p class="fontw mt30">2. 用户帐号安全</p>
          <p>完成本服务的注册程序并成功注册之后，您可使用您的手机号和密码，登录到您在快哦的帐号。保护您的帐号安全，是您的责任。您同意：</p>
          <p><span class="mr10">•</span>您应对所有使用您的密码及帐号的活动负完全的责任，包括但不限于您在快哦中进行的任何数据修改、款项支付、内容讨论等行为。您应高度重视对账号与密码的保密，在任何情况下不向他人透露账号及密码。您的快哦帐号遭到未获授权的使用，或者发生其它任何安全问题时，您将立即通知快哦。</p>
          <p><span class="mr10">•</span>如果您未保管好自己的帐号和密码，因此而产生的任何损失或损害，快哦无法也不承担任何责任。</p>
          <p><span class="mr10">•</span>您有责任维护个人账号、密码的安全性与保密性，并对您以注册账号名义所从事的活动承担全部法律责任。如果您未保管好自己的帐号和密码而对您、快哦或第三方造成的损害，您将负全部责任。</p>
        </div>
        <div class="mb60">
          <p class="fontw">三、用户信息保护及授权</p>
          <p>1. 您知悉并同意，为方便您使用本平台相关服务，本平台将按照本协议及《隐私政策》的规定收集、使用、存储和分享您的个人信息与必要信息，包括但不限于您的登记资料、查询记录、查询结果等。除法律法规规定、《隐私政策》约定或另有约定的情形外，未经您的许可快哦不会获取、存储或向第三方公开、透露您的个人信息。</p>
          <p>
            2. 您知悉并确认，您在注册账号或使用本平台的过程中，需要提供真实的身份信息，快哦将根据国家法律法规的要求，采用邮箱、移动电话等进行真实身份信息认证。若您提供的信息不真实、不完整，则无法使用本平台或在使用过程中受到限制，由此产生的不利后果，由您自行承担。
          </p>
          <p>3. 快哦将运用各种安全技术和程序、建立完善的管理制度来保护您的个人信息，防止您的信息被不当使用或遭受未经授权的访问、使用或披露。</p>
          <p>4. 未经您的同意，快哦不会向其他任何公司、组织和个人披露您的个人信息，除非：</p>
          <p><span class="mr10">•</span>相关法律法规或司法机关、行政机关要求；</p>
          <p><span class="mr10">•</span>为完成合并、分立、收购或资产转让而转移；</p>
          <p><span class="mr10">•</span>为提供您要求的服务所必须；</p>
          <p><span class="mr10">•</span>依照《隐私政策》或其他协议规则可以转移或披露给第三方的情形。</p>
          <p><span class="mr10">•</span>快哦非常重视对未成年人信息保护，若您不具备完全民事行为能力，在使用快哦前，应事先取得您的监护人同意。</p>
        </div>
        <div class="mb60">
          <p class="fontw">四、用户行为规范</p>
          <p class="fontw">1. 信息内容规范</p>
          <p>您应对使用快哦平台及服务发布信息内容的真实性、合法性负责。如需获得该信息内容权利人或任何有权第三方的事先授权或批准的，应事先获得该等授权或批准；一旦您发布某项信息内容，将被视为您已事先获得该等授权或批准。</p>
          <p>1.1 本条所述信息内容是指用户利用快哦下载、使用、发布、传播的任何内容，包括但不限于用户的昵称、头像、用户说明等注册信息，或您使用快哦发布的文字、图片、音频、视频等，以及其他使用快哦所产生的内容。</p>
          <p>1.2 您理解并同意，快哦一直致力于为用户提供文明健康、规范有序的网络环境，您不得利用快哦发布、传播任何违法违规内容，包括但不限于：</p>
          <p><span class="mr10">•</span>反对宪法所确定的基本原则的；</p>
          <p><span class="mr10">•</span>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一，损害国家荣誉和利益的；</p>
          <p><span class="mr10">•</span>煽动民族仇恨、民族歧视、破坏民族团结的；</p>
          <p><span class="mr10">•</span>破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
          <p><span class="mr10">•</span>散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
          <p><span class="mr10">•</span>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
          <p><span class="mr10">•</span>侮辱或者诽谤他人，侵害他人合法权利的；</p>
          <p><span class="mr10">•</span>含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；</p>
          <p><span class="mr10">•</span>侵犯他人隐私、个人信息、著作权、商标权等知识产权或合法权利的内容；</p>
          <p><span class="mr10">•</span>散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息；</p>
          <p><span class="mr10">•</span>含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的或含有快哦认为不适合展示的内容。</p>
          <p class="fontw mt30">2. 软件使用规范</p>
          <p>您同意按照本协议约定的方式合理合法地使用快哦，除非法律允许或快哦书面许可，您通过快哦分享、下载、使用、传播、发布的任何图片、视频及其他内容，仅限您个人使用，您不得有偿或无偿转让依本协议条款所取得的用户权利，且不得从事下列行为：</p>
          <p><span class="mr10">•</span>对快哦拥有知识产权的内容进行销售、出租、出借、复制、修改、链接、转载、汇编、发表、出版等；</p>
          <p><span class="mr10">•</span>对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；</p>
          <p><span class="mr10">•</span>未经合法授权而截获、篡改、收集、储存或删除他人个人信息、站内邮件或其它数据资料，或将获知的此类资料用于任何非法或不正当目的；</p>
          <p><span class="mr10">•</span>对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经快哦授权的第三方工具/服务接入本软件和相关系统；</p>
          <p><span class="mr10">•</span>通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</p>
          <p><span class="mr10">•</span>通过非快哦开发、授权的第三方软件、插件、外挂、系统，登录或使用快哦平台及服务，或制作、发布、传播上述工具；</p>
          <p><span class="mr10">•</span>自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰；</p>
          <p><span class="mr10">•</span>使用任何方式（包括但不限于第三方软件、插件、外挂、系统、设备等）对快哦进行干扰、破坏、修改或实施其他任何危害网络安全的活动；</p>
          <p><span class="mr10">•</span>其他违反法律法规、政策或未经快哦明示授权的行为；</p>
          <p>除本协议约定外，快哦还将在服务平台内以各种形式提醒用户规范使用快哦提供的各项服务，您须遵守。您已认可快哦未对用户的使用行为进行全面控制，您使用任何内容时，包括依赖前述内容之正确性、完整性或合法性时，您同意将自行加以判断并承担所有风险，快哦在法律允许的范围内不对您因前述风险而导致的任何损失或损害承担责任。在任何情况下，若快哦有理由认为您的任何行为违反或可能违反上述约定的，快哦可独立进行判断并处理，且有权在未经通知的情况下终止向您提供服务，并追究相关责任。若您违反本协议约定使用快哦提供的服务而被第三方追责的，由您自行承担全部责任。</p>
        </div>
        <div class="mb60">
          <p class="fontw">五、违约处理</p>
          <p>1. 如果快哦发现或收到他人举报投诉您违反本协议或存在任何恶意行为的，快哦有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规账号除以包括但不限于警告、限制或禁止使用全部或部分功能、账号封禁、注销等处罚，并公告处理结果。快哦有权对涉嫌违反法律法规、涉嫌违法犯罪的行为保存有关记录，并依法向有关主管部门报告、配合有关主管部门调查。对已删除内容公司有权不予返还。</p>
          <p>2. 因您违反本协议或其他条款规定，引起第三方投诉或诉讼索赔的，您应当自行承担全部法律责任。因您的违法或违约行为导致快哦及其关联公司向任何第三方赔偿或遭受国家机关处罚的，您还应足额赔偿快哦及其关联公司因此遭受的全部损失。</p>
          <p>3. 公司尊重并保护法人、公民的知识产权、名誉权、姓名权、隐私权等合法权益。您保证，在使用快哦上传的文字、视频、音频、链接等不侵犯任何第三方的知识产权、名誉权、姓名权、隐私权等权利及合法权益。否则，快哦有权在收到权利方或者相关方通知的情况下移除该涉嫌侵权内容。针对第三方提出的全部权利主张，您应自行承担全部法律责任；如因您的侵权行为导致快哦及其关联公司遭受损失的（包括但不限于经济、商誉等损失），您还应足额赔偿快哦及其关联公司遭受的全部损失。</p>
        </div>
        <div class="mb60">
          <p class="fontw">六、服务的中断和终止</p>
          <p>1. 您理解并同意，快哦有权于任何时间暂时或永久修改或终止本服务（或其任何部分），且无论通知与否。您同意对于本服务所作的任何修改、暂停或终止，快哦对您和任何第三人均无需承担任何责任，您应妥善做好数据更新、备份与转移工作。</p>
          <p>2. 因您违反本协议，快哦有权根据实际情况中断或终止其中一项或多项服务，严重违反的，快哦将直接终止您对快哦的使用权。</p>
          <p>3. 您对本协议内容有异议，或对快哦提供的服务不满意，可行使如下权利：</p>
          <p><span class="mr10">•</span>停止使用快哦账号服务；</p>
          <p><span class="mr10">•</span>自行注销或通知快哦注销您的账号。账号注销将导致您在快哦上的个人信息、查询记录，上传图片等一并删除，您和快哦相应的权利义务随之终止（您的任何损害赔偿义务不会因此而终止），快哦不承担传送任何未处理的信息或未完成的服务给您的责任。</p>
        </div>
        <div class="mb60">
          <p class="fontw">七、第三方产品及服务</p>
          <p>1. 您在使用本软件中由第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。如因您使用由第三方提供的产品或服务时引发的任何纠纷，应由您和第三方负责解决，快哦不承担任何责任。</p>
          <p>2. 您在使用本软件中由第三方提供的产品或服务时，本软件可能会调用第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供，快哦不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与快哦无关，快哦不承担任何责任。</p>
        </div>
        <div class="mb60">
          <p class="fontw">八、广告</p>
          <p>1. 快哦中可能包含广告，这属于快哦及其关联公司合理合法的商业模式，您同意在使用快哦过程中接收由快哦及其关联公司或者其第三方合作伙伴发布的广告信息或其他信息（包括商业与非商业信息），信息的具体发送及展示形式、频次及内容等以快哦实际提供为准。</p>
          <p>2. 您通过本网站与广告商及其他第三方进行任何形式的通讯或商业往来，或参与促销活动，包含相关商品或服务之付款及交付，以及达成的其它任何相关条款、条件、保证或声明，完全为您与广告商及其他第三方之间之行为。您应当自行判断广告信息的真实性并为自己的判断行为负责，除法律明确规定外，您因前述任何交易或前述广告商及其他第三方而遭受的任何性质的损失或损害，快哦对此不负任何法律责任。</p>
        </div>
        <div class="mb60">
          <p class="fontw">九、增值服务</p>
          <p>1. 快哦可能会对部分服务开始收费，也可能在将来采取付费模式，并根据实际需要对付费模式的收费标准、方式进行调整与完善。如您使用收费服务，请遵守相关的协议。若您不同意相关协议及其修改和变更，请暂停使用增值服务。若您为未满18周岁的未成年人，请您在法定监护人陪同下，认真仔细阅读增值服务相关协议并选择是否接受该协议及其服务。</p>
          <p>2. 在快哦降低增值服务的收费标准或者将收费服务改为免费服务提供时，快哦保留不对原付费用户提供退费或者费用调整的权利。</p>
        </div>
        <div class="mb60">
          <p class="fontw">十、其他条款</p>
          <p>1. 您登录、使用快哦即视为您已阅读并同意受本协议的约束。</p>
          <p>2. 快哦有权依据国家政策、技术条件、产品功能等变化需要而进行修改本协议，并将修改后的协议予以发布。您可在快哦的最新版本中查阅更相关协议条款。本协议条款变更后，如果您继续使用快哦，即视为您已接受修改后的协议。</p>
          <p>本协议内容同时包括快哦已经发布及后续可能不断发布的相关协议、规则等内容（包括《隐私政策》）。前述内容已经发布，公司将以适当的方式（网站公布、系统通知等）提醒您及时阅读。前述相关协议、规则构成本协议不可分割的组成部分，您应同样遵守。</p>
          <p>3. 除非本协议另有其它明示规定，快哦增加或强化目前本任何新功能，包括所推出的新产品，均受到本使用协议之规范。</p>
          <p>4. 本协议的成立、生效、履行、解释及争议解决均适用中华人民共和国的法律。</p>
          <p>5. 本协议及所有条款之标题仅供方便而设，不具任何法律或契约效果。</p>
          <p>6. 快哦对于您所有的通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等方式进行（联系方式以您在平台预留的为准）；该等通知于发送之日视为已送达收件人。</p>
        </div>
        <p class="tr">本次更新时间为2020年4月20日</p>
      </div>
      <!-- <footerBar></footerBar> -->
    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button type="primary"
                 @click="dialogVisible = false" style="width:150px">同 意</el-button>
    </span>
  </el-dialog>
</template>

<script>
import navBar from '../nav/nav.vue'
import footerBar from '../footer/footer'

export default {
  components: { navBar, footerBar },
  props: [],
  data() {
    return {
      dialogVisible: false
    }
  },
  mounted() { },
  created() { },
  methods: {
    close() {
      this.dialogVisible = false
    }
  },
}
</script>

<style lang="scss" scoped>
.userPactView {
  height: 700px;
  font-size: 14px;
  line-height: 1.6;
  overflow: auto;
  .userPactContent {
    background: #fff;
    margin: 10px auto;
    padding: 0 20px;
    .itemP {
      /* display: flex;
      align-items: flex-start; */
      span {
        margin-right: 5px;
      }
    }
  }
  .mb60 {
    margin-bottom: 60px;
  }
}
</style>